import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import NewsList2025 from "../../component/IITTP/News/NewsList2025.js";
import NewsList2024 from "../../component/IITTP/News/NewsList2024.js";
// import NewsList2023 from "../../component/IITTP/News/NewsList2023.js";
import Ann2026 from "../../component/IITTP/Announcements/Ann2026.js";
import Ann2025 from "../../component/IITTP/Announcements/Ann2025.js";
import Ann2024 from "../../component/IITTP/Announcements/Ann2024.js";

import Iframe from 'react-iframe'

function News() {

    
    const combinedNews = [...NewsList2025, ...NewsList2024];

    // Get the latest 7 news
    
    const latestNews = combinedNews.slice(0, 7);
    

    // const latestNews = [
    //     {
        
    //         desc: <News NewsList={NewsList2023.desc} />
    //     },
    // ];  

    // const  latestNews2 = [
    //     {
    //         desc:`Prof KSMS Raghava Rao has been awarded the prestigious "Life Time Achievement Award" by International Association of Engineering and Food.`,
    //     },
    //     {
    //         desc:`Mr. Allabakshi S. M, Civil Engineering Research scholar received the first prize in "Best oral presentation award category".`,
    //     },
    //     {
    //         desc:`Mr. V. Sunil - MS Scholar under guidance of Dr. Uday Kumar Sukumar & Dr. K. Anki Reddy, Department of Chemical Engineering, got selected for "Khorana Program of Internships - 2023"`,
    //     },
    //     {
    //         desc: `Mr. Vikrant Yadav and Mr. Sonu Jana - Department of Physics, Research scholars have been awarded the prestigious "MITACS GLOBALINK RESEARCH" Award.`,
    //     },
    //     {
    //         desc:`Mr. Allabakshi S. M, Civil Engineering Research scholar received the first prize in "Best Paper Award Category".`,
    //     },
    //     {
    //         desc:`Ms. Vajitha. G, Civil Engineering Research scholar received the "Best poster presentation award".`,
    //     }

        
    // ];

    const combinedAnnounce = [...Ann2026, ...Ann2025];

    // Get the latest 7 news

    const latestAnnounce = combinedAnnounce.slice(0, 8);


    // const  latestAnnounce = [
    //     {
    //         desc:`Advertisement for the position of Junior Research Fellow`,
    //     },
    //     {
    //         desc:`Notification for Technical Positions - Engineering Unit (Outsourced Position)`,
    //     },
    //     {
    //         desc:`Notification for Sports Coaches & Gym Trainer - Hostel and Mess Establishment (Outsourced Position)`,
    //     },
    //     {
    //         desc: `Orientation Program for MS/Ph.D. Research Scholars - July 24, 2023`,
    //     },{
    //         desc: `Orientation Program for M.Tech/M.Sc./MPP - July 27, 2023`,
    //     },{
    //         desc: `Advertisement for the position of Junior Research Fellow - Mechanical Engineering`,
    //     },{
    //         desc: `Notification for Laboratory Assistant (Outsourced Position) - Department of Physics`,
    //     }
        
    // ];

  return (
    <>
        <section className="event event03 pt-40 pb-90 p-relative fix" style={{ background: "#f7f9ff" }}>
            <div className="container">
                <div className="row">
                
                <div className="col-lg-6 col-md-12  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                    <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                        {/* <h5>
                            <i className="fal fa-graduation-cap" /> News
                        </h5> */}
                        <h2 className='titleh3'>Latest News</h2>
                    </div>
                    <div className='newspaper scrollbar2'>
                        {latestNews.map((currNews, index) => (
                            <div className="event-item mb-10 hover-zoomin" key={index}>
                                <div className="event-content" >
                                    <div className="icon">
                                        <i className="fal fa-newspaper" />
                                    </div>
                                    <div className="text ">
                                        <h6>
                                            <Link to={currNews.link} target='_blank'>
                                            {" "}
                                            {currNews.desc}
                                            </Link>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        ))}
                        
                    </div>
                    <div className="slider-btn mt-3 float-end">
                        <Link to="/news" className="btn ss-btn smoth-scroll">
                            View All<i className="fal fa-long-arrow-right" />
                        </Link>
                    </div>
                </div>
                <div className="col-lg-6 col-md-12  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                    <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                    {/* <h5>
                        <i className="fal fa-graduation-cap" /> Announcements
                    </h5> */}
                    <h2 className='titleh3'>Latest Announcements</h2>
                    </div>
                    <div className='newspaper scrollbar3'>
                        {latestAnnounce.map((currNews, index) => (
                            <div className="event-item mb-10 hover-zoomin" key={index}>
                                <div className="event-content">
                                    <div className="icon">
                                        <i className="fas fa-bullhorn" />
                                    </div>
                                    <div className="text ">
                                        <h6>
                                            <Link to={currNews.link} target="_blank">
                                                {currNews.blink && (
                                                    <span className="me-1 align-middle">
                                                        <img
                                                            src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif"
                                                            alt="New"
                                                            style={{
                                                                display: 'inline-block',
                                                                width: '36px',
                                                                height: '20px',
                                                                verticalAlign: 'middle'
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                                {currNews.title}
                                            </Link>
                                            <div className="d-flex">
                                                {currNews.notifyLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.notifyLink}>Notification</Link>
                                                }
                                                {currNews.appLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.appLink}>Application Form</Link>
                                                }
                                                {currNews.eligibilityLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.eligibilityLink}>Eligibility & Apply Link</Link>
                                                }
                                                {currNews.shortLink && 
                                                  <Link target="_blank" className=" btn-small" to={currNews.shortLink}>Shortlisted List</Link>
                                                 }
                                                 {currNews.syllabusLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.syllabusLink}>Syllabus</Link>
                                                  }
                                                  {currNews.corrigendumLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.corrigendumLink}>Corrigendum</Link>
                                                }
                                                {currNews.schemeLink && 
                                                <Link target="_blank" className=" btn-small" to={currNews.schemeLink}>Schemes</Link>
                                                }
                                                {currNews.guideLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.guideLink}>Guidelines</Link>
                                                }
                                                {currNews.userLink && 
                                                    <Link target="_blank" className=" btn-small" to={currNews.userLink}>User manual</Link>
                                                }
                                        </div>
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="slider-btn mt-3 float-end">
                        <Link to="/announcements" className="btn ss-btn smoth-scroll">
                            View All<i className="fal fa-long-arrow-right" />
                        </Link>
                    </div>
                    </div>
                </div>
            </div>
        </section>

        
    </>
  )
}

export default News